import service from './service'

export default {
  // UTILS
  getFlightCalendar(params) {
    return service.get('/utils/calendar', params)
  },

  // FLIGHTS SCHEDULE
  getFlightsSchedule(params) {
    return service.get('/utils/flight-schedule', params)
  },

  getFlightsScheduleConfigs() {
    return service.get('/utils/flight-schedule/config')
  },
}
